import React, { useCallback, useContext, useEffect, useState } from 'react';

import moment from 'moment';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { DatePicker } from 'ui-components/components/date-picker';

import Global from '../../../../../../../store/global-selectors';
import { ReportsContext } from '../../../context';

const FilterDatePicker = ({ props: { apiKey } }) => {
  const { setReportParams } = useContext(ReportsContext);
  const dateFormat = useSelector(Global.selectUserUserDateFormat);
  const [date, setDate] = useState(moment().format(dateFormat));

  // oxlint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => setReportParams({ apiKey, value: date }), []);

  const onChange = useCallback(
    (value) => {
      setDate(value);
      setReportParams({ apiKey, value });
    },
    [apiKey, setDate, setReportParams],
  );

  return <DatePicker allowPastDates dateFormat={dateFormat} onChange={onChange} value={date} />;
};

FilterDatePicker.propTypes = {
  props: PropTypes.shape({
    apiKey: PropTypes.string,
  }).isRequired,
};

export default FilterDatePicker;
